"use client";

export default function LobbyMatchLeagues({
  matches = [],
  render = () => null,
}) {
  return (
    <div className="border border-[var(--theme-border)] border-t-0 rounded-bl-lg rounded-br-lg overflow-hidden">
      <div className="kbv-wr-schedule-header bg-[var(--theme-highlight)] h-9 items-center px-2 text-[var(--theme-text)] text-xsm leading-5 hidden md:grid grid-cols-[minmax(0,24fr)_minmax(0,10fr)_minmax(0,25fr)_25px_minmax(0,19.5fr)_minmax(0,19.5fr)_minmax(0,19.5fr)] gap-2">
        <div className="min-w-0 overflow-hidden text-ellipsis whitespace-nowrap box-border text-[var(--theme-text)]">
          Giải đấu
        </div>
        <div className="text-center min-w-0 overflow-hidden box-border text-[var(--theme-text)]">
          Ngày
        </div>
        <div className="min-w-0 overflow-hidden text-ellipsis whitespace-nowrap box-border text-[var(--theme-text)]">
          Trận đấu
        </div>
        {/* Label column placeholder */}
        <div className="w-[25px]" />
        <div className="text-center min-w-0 overflow-hidden box-border text-[var(--theme-text)]">
          Kèo chấp
        </div>
        <div className="text-center min-w-0 overflow-hidden box-border text-[var(--theme-text)]">
          Kèo tài xỉu
        </div>
        <div className="text-center min-w-0 overflow-hidden box-border text-[var(--theme-text)]">
          1x2
        </div>
      </div>
      <div className="schedule-scrollbar-hide overflow-x-hidden overflow-y-auto bg-[var(--theme-bg)]/60 backdrop-blur-sm">
        {matches.map((match, idx) => render(match, idx))}
      </div>
    </div>
  );
}
